import { ValueType } from 'modules/queryBuilder/legacyQueryBuilder/types';

export const valueTypeLabels = {
  [ValueType.Custom]: 'Custom Value',
  [ValueType.Contact]: 'Contact Property',
  [ValueType.Trigger]: 'Trigger Property',
};
